import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=47aba244&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=js"
export * from "./Recommend.vue?vue&type=script&lang=js"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=47aba244&prod&lang=css"
import style1 from "./Recommend.vue?vue&type=style&index=1&id=47aba244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aba244",
  null
  
)

export default component.exports